<template>
	<ElementButton
		name="download"
		i18n
		:content="content"
		:state="partState"
		@click.stop="click"
		data-url="command://noOp"
	/>
</template>

<script>
import { PACKAGE_SYNCER_STATE } from '../../tools/consts';
import { mapActions, mapState, mapGetters } from 'vuex';
import { getterTypes, actionTypes, errorTypes} from '../../types';
import errorHandler from '../../tools/errorHandler';

export default {
	props: {
		subPartID: String,
	},
	computed: {
		...mapState(['packageSyncer']),
		...mapGetters([getterTypes.packageSyncerPartState]),
		package() {
			if (this.packageSyncer.subParts[this.subPartID]) {
				return this.packageSyncer.subParts[this.subPartID];
			} else {
				errorHandler(new Error(errorTypes.packageSyncerUnkownSubPart));
				return {};
			}
		},
		packageState() {
			return this.package.state;
		},
		content() {
			if (
				this.packageSyncerPartState(this.subPartID) === PACKAGE_SYNCER_STATE.notDownloaded &&
				!this.packageSyncerPartState(this.subPartID).isSelected
			)
				return 'download';
			if (
				this.packageSyncerPartState(this.subPartID) === PACKAGE_SYNCER_STATE.notDownloaded &&
				this.packageSyncerPartState(this.subPartID).isSelected
			)
				return 'update';
			if (this.packageSyncerPartState(this.subPartID) === PACKAGE_SYNCER_STATE.downloading)
				return 'downloading';
			if (this.packageSyncerPartState(this.subPartID) === PACKAGE_SYNCER_STATE.downloaded)
				return 'delete';
			if (this.packageSyncerPartState(this.subPartID) === PACKAGE_SYNCER_STATE.waiting)
				return 'waiting';
		},
		partState() {
			return this.packageSyncerPartState(this.subPartID);
		},
	},
	methods: {
		...mapActions([actionTypes.packageSyncerDownloadSubPart, actionTypes.packageSyncerDeleteSubPart]),
		click(event) {
			event.stopPropagation();
			event.stopImmediatePropagation();
			if (this.packageSyncerPartState(this.subPartID) === PACKAGE_SYNCER_STATE.notDownloaded) {
				this.packageSyncerDownloadSubPart({ subPartID: this.subPartID });
				return;
			}
			if (this.packageSyncerPartState(this.subPartID) === PACKAGE_SYNCER_STATE.downloaded) {
				this.packageSyncerDeleteSubPart({ subPartID: this.subPartID });
				return;
			}
			return;
		},
	},
	watch: {
		partState(newState) {
			this.$el.parentNode.setAttribute('sub-part-state', newState);
		},
	},
	mounted() {
		if (this.$el.parentNode) {
			this.$el.parentNode.setAttribute('sub-part-state', this.partState);
		}
	},
};
</script>

<style lang="scss"></style>
